var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.src),function(image){return _c('van-swipe-item',{key:image.id,on:{"click":function($event){return _vm.toPlays(image.data_id)}}},[_c('van-image',{attrs:{"src":image.banner_pic,"width":"100%","lazy-load":""}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }